import React from "react"
import { Card, CardMedia, Grid2, IconButton, Stack, Typography } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import { SelectedImage } from "@/features/bulkedit/types"

interface SelectedImagesGridProps {
  images: SelectedImage[]
  maxImages: number
  onRequestDelete: (imageId: string) => void
}

const SelectedImagesGrid: React.FC<SelectedImagesGridProps> = ({ images, maxImages, onRequestDelete }) => {
  if (images.length === 0) {
    return null
  }

  return (
    <Stack spacing={1.5}>
      <Typography variant="h6" fontWeight={700}>
        Selected Images ({images.length}/{maxImages})
      </Typography>
      <Grid2 container spacing={2}>
        {images.map(image => (
          <Grid2 size={{ xs: 6, sm: 4, md: 3 }} key={image.id}>
            <Card sx={{ position: "relative" }}>
              <CardMedia component="img" image={image.previewUrl} alt={image.file.name} sx={{ height: 140 }} />
              <IconButton
                size="small"
                onClick={() => onRequestDelete(image.id)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.75)" }
                }}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Stack>
  )
}

export default SelectedImagesGrid
